import { useSetAtom } from "jotai";

import { $cloneWorkflow } from "../../internal/clone-document/clone.workflow.atom";

export const useCloneDocument = () => {
	const cloneDocument = useSetAtom($cloneWorkflow);

	return cloneDocument;
};
